module.exports = __webpack_public_path__ + "img/invoice-de-female-bb.c803f434.png";